"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utcStart = exports.humanizeMinutesDuration = exports.getUtcStartOfDay = exports.getTimeZoneDate = exports.getSortedTimezonesList = exports.getDiffInMinutes = exports.getAgendaDays = exports.formatTime = exports.formatDate = exports.dateAndMinutesToTimestamp = exports.SECOND = exports.MINUTE = exports.MILLISECOND = exports.HOUR = exports.DAY = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MILLISECOND = 1;
exports.MILLISECOND = MILLISECOND;
var SECOND = MILLISECOND * 1000;
exports.SECOND = SECOND;
var MINUTE = SECOND * 60;
exports.MINUTE = MINUTE;
var HOUR = MINUTE * 60;
exports.HOUR = HOUR;
var DAY = HOUR * 24;
exports.DAY = DAY;
var DATE_FORMAT = 'YYYY MM DD';

var timeStampToDateString = function timeStampToDateString(date, timezone) {
  return (0, _moment.default)(date).tz(timezone).format(DATE_FORMAT);
};

var dateStringToUtcTimestamp = function dateStringToUtcTimestamp(stringDate) {
  return _moment.default.tz(stringDate, DATE_FORMAT, 'UTC');
};

var MIN = 'min';
var MINS = 'mins';

var utcStart = function utcStart(date, timezone) {
  return timezone ? dateStringToUtcTimestamp(timeStampToDateString(date, timezone)) : (0, _moment.default)(date).utc().startOf('day');
};

exports.utcStart = utcStart;

var getUtcStartOfDay = function getUtcStartOfDay(date, timezone) {
  return utcStart(date, timezone).valueOf();
};

exports.getUtcStartOfDay = getUtcStartOfDay;

var formatDate = function formatDate(date, format) {
  return utcStart(date).format(format);
};

exports.formatDate = formatDate;

var formatTime = function formatTime(minutes, format) {
  return utcStart().startOf('day').add(minutes, 'm').format(format);
};

exports.formatTime = formatTime;

var humanizeMinutesDuration = function humanizeMinutesDuration(minutes) {
  var duration = _moment.default.duration(minutes, 'minutes').format('h [hours], m [min]', {
    trim: 'both'
  });

  if (duration.includes(MINS)) {
    duration = duration.replace(MINS, MIN);
  }

  return duration;
};

exports.humanizeMinutesDuration = humanizeMinutesDuration;

var getDiffInMinutes = function getDiffInMinutes(start, end) {
  var startMinute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var endMinute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return utcStart(end).add(endMinute, 'm').diff(utcStart(start).add(startMinute, 'm'), 'minutes');
};

exports.getDiffInMinutes = getDiffInMinutes;

var dateAndMinutesToTimestamp = function dateAndMinutesToTimestamp(startDate, startMinute) {
  return (0, _moment.default)(startDate).add(startMinute, 'minutes').valueOf();
};

exports.dateAndMinutesToTimestamp = dateAndMinutesToTimestamp;

var getAgendaDays = function getAgendaDays(startDate, endDate) {
  var days = [];

  for (startDate; startDate <= endDate; startDate += DAY) {
    days.push(startDate);
  }

  return days;
};

exports.getAgendaDays = getAgendaDays;

var getTimeZoneDate = function getTimeZoneDate(date, minutes, timeZone) {
  var startDate = utcStart(date);

  if (timeZone) {
    var offset = _moment.default.tz(startDate.format('YYYY-MM-DD'), timeZone).minutes(minutes).format('Z');

    return _moment.default.tz("".concat(startDate.format('YYYY-MM-DD HH:mm')).concat(offset), timeZone).minutes(minutes);
  }

  return startDate.minutes(minutes);
};

exports.getTimeZoneDate = getTimeZoneDate;
var NOT_SUPPORTED_TIMEZONES = ['EST', 'HST', 'MST', 'ROC'];

var getSortedTimezonesList = function getSortedTimezonesList(eventStartDate) {
  var timeZones = [];

  var sortByGMT = function sortByGMT(a, b) {
    var _a$displayName$split$ = a.displayName.split('GMT')[1].split(')')[0].split(':'),
        _a$displayName$split$2 = _slicedToArray(_a$displayName$split$, 2),
        ahh = _a$displayName$split$2[0],
        amm = _a$displayName$split$2[1];

    var _b$displayName$split$ = b.displayName.split('GMT')[1].split(')')[0].split(':'),
        _b$displayName$split$2 = _slicedToArray(_b$displayName$split$, 2),
        bhh = _b$displayName$split$2[0],
        bmm = _b$displayName$split$2[1];

    return +ahh * 60 + amm - (+bhh * 60 + bmm);
  };

  _momentTimezone.default.tz.names().forEach(function (timeZone) {
    if (!NOT_SUPPORTED_TIMEZONES.includes(timeZone)) {
      timeZones.push({
        value: timeZone,
        displayName: "(GMT".concat(_moment.default.tz(eventStartDate, timeZone).format('Z'), ") ").concat(timeZone)
      });
    }
  });

  return timeZones.sort(sortByGMT);
};

exports.getSortedTimezonesList = getSortedTimezonesList;